<template>
  <div id="content" class="startup_page">
    <div class="container content_div">
      <div class="col-12 text-center">
        <div class="poolTitle">
          <h2 class="customH2 text-center">Profiles in progress
        </h2>
        </div>
        <div class="mt20 ">
           <div class="col-12 action_zone">
             <span class="actionZoneTitle">CHOOSE YOUR ACTION </span>
            <!-- <router-link class="prev_step_btn_small" v-if="selected_filters.length > 0" :to="'/startup_with_filters_graph/'+this.$route.params.search_field+'/'+JSON.stringify(selected_filters)+'/'+this.$route.params.pid">Graph view</router-link> -->
            <div class="goRight">
              <div class="quicksearch">
                  <input type="text" class="input" placeholder="Search by name"  v-model="quicksearch">
              </div>

            </div>
          </div>

        <div class="table-responsive mt20"  v-if="startups_quicksearch">

        <table class="table table-stripped">
          <thead class="thead-dark">
        <tr>
          <th>Innovators name</th>
          <th>Key contact</th>
          <th>Email</th>
          <th>Website</th>
          <th>Profile created</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(startup,s) in startups_quicksearch" :key="s">
          <td>{{startup.name}}</td>
          <td>{{startup.key_contact_name}}</td>
          <td><a class="nodeco" :href="'mailto:'+startup.key_contact_email">{{startup.key_contact_email}}</a></td>
          <td>{{startup.website}}</td>
          <td>{{startup.initializeDate}}</td>
          <td>
            <button type="button" @click="deltePartialStartup(startup._id.$oid)"  class="btn remove" name="button">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="" v-else>
    <div class="alert alert-warning text-center mt50">
        No innovators available
    </div>
  </div>
        </div>

      </div></div></div>
</template>
<script>
import api from '@/tools/api';
// import { debounce } from 'lodash';
 //import AddCommentModal from '@/components/modals/addCommentWithList.vue'
// import {
//   VueCollapsiblePanelGroup,
//   VueCollapsiblePanel,
// } from '@dafcoe/vue-collapsible-panel'
// import '@dafcoe/vue-collapsible-panel/dist/vue-collapsible-panel.css'
  import { toast } from 'vue-sonner'
 //  import LongListUploader from '@/components/LongListUploader.vue'
 //  import NewFilter from '@/components/NewFilter.vue'
 // import AddToListModal from '@/components/modals/addToList.vue'
export default {
  components: {
    // VueCollapsiblePanelGroup,
    // VueCollapsiblePanel,
    // AddCommentModal,
    // LongListUploader,
    // AddToListModal,
    // NewFilter
  },
  name: 'PartialStartupsLists',
  data() {
    return {
      pageInfo: {
        mainTitle : "Link+ management",
        subTitle : "Explore innovators in progress ",
      },
      startups : [],
      startups_quicksearch: [],
      quicksearch: "",
    }
  },
  computed: {

  },
  methods:{
    deltePartialStartup(id){
      if (window.confirm(this.$t("Do you really want to delete this innovator and all his data?"))) {
        console.log(id);
        api.post(process.env.VUE_APP_API_URL+"/restrict/delete_partial_startup",{
          startup:id,
         },{
             headers: {
                 'Content-Type': 'application/json',
             }
         }).then( (r) => {
             console.log(r);
             toast.success("Innovator deleted");
             this.reloadStartups();
         }).catch( () => toast.error("An error has occurred during expert assignment"));

      }
    },
    reloadStartups(){
      api.get(process.env.VUE_APP_API_URL+"/restrict/list_partial_startups",{
        headers: {
            'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r.data);
        this.startups = r.data;

        this.startups.forEach((s) => {
          var initializeDate =s.initializeDate.date.split(' ')[0];
          var te  =initializeDate.split('-');
          s.initializeDate = te[2]+"/"+te[1]+"/"+te[0]
          console.log(s);
        });

        this.startups_quicksearch = r.data;
      }).catch( error => {
        if(error.response.data.message) toast.error(error.response.data.message);
        else toast.error("Sorry, an error occurs. Please try again !");
      })
    },
    getBaseUrl(url){
      var formated = url.replace(/^https?:\/\//, '').replace(/\/$/, '');
      try{
        var r= new URL(url).origin;
        r = r.replace(/^https?:\/\//, '').replace(/\/$/, '');
        return r;
      }catch{
        return formated;
      }
    },
    getHttpsUrl(url){
      var f = url;
      if (!url.startsWith("https://")  && !url.startsWith("htts://") ) {
                  f = "https://" + url;
              }
              return f;
    },


    gobackrouter : function(){
      this.$router.go(-1);
    },
  },
  mounted(){
    this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
    api.get(process.env.VUE_APP_API_URL+"/restrict/list_partial_startups",{
      headers: {
          'Content-Type': 'application/json',
      }
    }).then( (r) => {
      console.log(r.data);
      this.startups = r.data;

      this.startups.forEach((s) => {
        var initializeDate =s.initializeDate.date.split(' ')[0];
        var te  =initializeDate.split('-');
        s.initializeDate = te[2]+"/"+te[1]+"/"+te[0]
        console.log(s);
      });

      this.startups_quicksearch = r.data;
    }).catch( error => {
      if(error.response.data.message) toast.error(error.response.data.message);
      else toast.error("Sorry, an error occurs. Please try again !");
    })




  },
  watch: {
     // minscore : function(v){
     //   console.log(v);
     //   this.apply_filter();
     //
     // }
     quicksearch: function(v){
      console.log(v);
      this.startups_quicksearch = this.startups.filter(obj =>
        (obj.name.toString().toLowerCase().includes(v.toLowerCase()) || obj.key_contact_name.toString().toLowerCase().includes(v.toLowerCase()))
      );
    },
   },

}
</script>
<style scoped>

.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding-left:0 !important;
  padding-right: 0 !important;
  padding-top:50px;
  padding-bottom:50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}
.chart-container {
  position: relative;
}

.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}

.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.canvasjs-chart-credit{
  display:none;
}

.mt50{
  margin-top:50px;
}
.mb50{
  margin-bottom: 50px;
}
.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.clickable{
  cursor:pointer;
}
.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}

.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}


.titre{
  margin-bottom: 20px;
  color: #3783C5;
  text-transform: uppercase;
}


.checkbox {
  cursor: pointer;
  display: flex;
  align-items: center;
  /* margin-bottom:20px; */
}
.checkboxItem{
  margin-bottom: 20px;
}
.checkbox__input {
  position: absolute;
  width: 1.375em;
  height: 1.375em;
  opacity: 0;
  cursor: pointer;
}
.checkbox__input:checked + .checkbox__icon .tick {
  stroke-dashoffset: 0;
}
.checkbox__icon {
  width: 1.375em;
  height: 1.375em;
  flex-shrink: 0;
  overflow: visible;
}
.checkbox__icon .tick {
  stroke-dasharray: 20px;
  stroke-dashoffset: 20px;
  transition: stroke-dashoffset 0.2s ease-out;
}
.checkbox__label {
  margin-left: 0.5em;
}

.filtres{

  padding:0;
}
.filtres_head .customH2{
  display: block;
  width: 100%;
  background: #3783C5;
  color: #FFF;
  padding: 10px;
}
.filtre_list{
  padding:10px;
}


.prev_step_btn_small{
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 5px 20px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.next_step_btn_small, .next_step_btn_small:hover {
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 200px;
  opacity: 1;
  padding: 5px 20px;
  color: #FFF;
  margin: auto;
  display:block;
  margin-top:20px;
  margin-bottom: 20px;
}
.startup_zone_legend{
  align-self: top;
}
.zone_startups{
    align-self: center;
}
.zone_title{
  font-size: 25px;
  color: #3783C5;
  font-weight: 700;
  text-align: center;
  display:block;
  width:100%;
  text-align:center;

}
.zone_number{
  font-size: 16px;
  color: #3783C5;
  font-weight: 700;
  text-align: center;
  display:block;
  width:100%;
  text-align:center;

}

.row.zone{
  padding-bottom: 50px;
  padding-top:25px;
}

.startup_zone_legend.stickit .legend{
  position: sticky;
    top: 50%; /* Adjust the top value as needed */
}

.startup_zone_legend:not(.stickit){
  align-self: center;
}

.alert{
  margin:0;
}



.startup_selection_section{
  position:relative;
  padding-top:50px;
}

.filtre_list{
  display: grid;
    grid-template-columns: auto auto auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-rows: 100%;
    gap:10px;
}

.pad-50{
  padding-left:50px;
  padding-right:50px;
}
@media screen and (max-width: 690px){
  .candidate_card .candidate_links{
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px
  }
  .candidate_pool{
      padding: 20px;
    }
    .candidate_card .candidate_links .details{
      border-right: none;
      border-bottom:1px solid #DDD;
      padding-bottom: 20px;
    }
    .candidate_card .candidate_links .selectIt label{
    display:flex;
    align-items: center;
    gap: 5px;
    justify-content: start;
    flex-direction: row-reverse;
    }
    .filtre_list {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-rows: 100%;
  gap: 10px;
}
}


.candidate_comments{
  padding: 20px 50px;
  border-top: 1px solid #DDD;
  margin-top:auto;
}
.candidate_comments .one_comment{
  margin-top:10px;
  margin-bottom: 10px;
  font-size:12px;
  line-height:15px;
    position:relative;
}
.candidate_comments .one_comment:after {
  content: ""; /* This is necessary for the pseudo element to work. */
     display: block; /* This will put the pseudo element on its own line. */
     margin: 0 ; /* This will center the border. */
     width: 20%; /* Change this to whatever width you want. */
     padding-top: 10px; /* This creates some space between the element and the border. */

     border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
}
.candidate_comments small{
  font-size:12px;
}

.add_new_comment{
  font-size:12px;
  line-height:15px;
  color: #3785C5;
  text-transform: uppercase;
  margin-top:20px;
}
.add_new_comment img{
  width: 20px;
  margin-right: 10px;
}


.all_candidates_download_zone{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
margin-bottom:50px;
}


.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
margin-bottom: 10px;
}


.all_candidates_download_zone .title{

  font-size: 20px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
margin-bottom: 10px;
font-weight:500;
cursor : pointer;
}


.all_candidates_download_zone .description{
  display:block;
  margin-top:10px;
  margin-bottom: 20px;
  width:100%;
}
.all_candidates_download_zone a{
  color:#B38D2F !important;
}

.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
.next_step_btn img.left{
  margin-right:10px;
}
img.goFullWhite{
filter: brightness(0) invert(1);
}

.pool_subtitle{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
display:block;
}
.mb10{
  margin-bottom:10px;
}
.mt20{
  margin-top:20px;
}


/* .selectAll{
  border: 1px solid #CCC;
  border-radius: 200px;
  padding: 5px 20px;
  margin: auto;
    margin-top: auto;
  display: block;
  margin-top: 20px;
} */
.goToRight{

}

.candidate_card_head{
  background: #4c81c0;
  padding: 10px;
  color: #FFF;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 10px 10px 0px 0px;
  display:flex;
  align-content: center;
    align-items: center;
gap:10px;
min-height: 60px;
}


.score {
  height: 70px;
  width: 70px;
  -webkit-clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  text-align: center;
  background: #B38D2F;
  color: white;
  font-size:17px;
}

.score::before {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  content: '';
}
.candidate_card .candidate_info_content{
  padding:20px;
  flex-grow: 1;
}
.footer{
padding-left: 20px;
  padding-right: 20px;
    padding-bottom: 10px;
  font-weight:bold;
  text-transform: uppercase;
  color:#B38D2F !important;
  font-size:14px;
  display:flex;
  flex-wrap:wrap;
  gap:10px;
}

.footer a{
  margin-left: auto;
}
.footer *{
  color:#4c81c0 !important;
  font-size:14px;
}
.filtre_list .zone_input{
  position:relative;
}
.filter_content{
  position: absolute;
  top: calc(100% + 10px);
  z-index: 900;
  border: 1px solid #4c81c0;
  padding: 20px;
  display:flex;
  flex-direction: column;
  width:400px;
  gap:15px;
  background: #FFF;
  left: calc(50% - 200px);
  box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
-webkit-box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
-moz-box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
}

@media screen and (max-width:990px){
  .filter_content{
    left:-20px;
    right:-20px;
    width:350px;
}
}

.filter_content .value_possible{
  max-height:300px;
  overflow: scroll;
}
.filter_content .btn_invert{
  padding:10px;
  color:#4c81c0;
  background:#FFF;
  font-size:12px;
  border-radius: 20px;
  border:1px solid #4C81C0;
}

.filter_content .btn{
  padding:10px;
  background:#4c81c0;
  color:#FFF;
  font-size:12px;
  border-radius: 20px;
    border:1px solid #4C81C0;
}
.filter_content .flexBottom{
  display: flex;
    gap: 10px;
    flex-wrap: wrap;
align-self: end;
  margin-top:auto;
  align-items: center;
  width:100%;
}
.zone_input_header{
  border: 2px solid #4c81c0;
  padding: 10px;
  border-radius: 200px;
  cursor:pointer;
}
.zone_input{
  width:100% !important;
  position:relative;
}


.filtre_list_3{
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  border-left: 2px solid #CCC;
  padding-left: 20px;
}
.filtre_list_2{
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  /* justify-content: center;*/
  align-items: center;
  flex-grow:1;
}

.nb_item{
  background: #B38D2F;
  padding: 2px 10px;
  border-radius: 5px;
  font-size: 10px;
  color:#FFF;
  vertical-align: middle;
  margin-right: 5px;
}
.dflex{
  display: flex;
  gap: 10px;
justify-content: stretch;
}

.checkbox{
  position:relative;
}
.checkbox_hover{
  background:#FFF;
  font-size:10px;
  display:none;
}

.checkboxItem:hover  .checkbox_hover{
  display:block;
}
.onecondition{
  width:100%;
  display:block;
}

.website{
  color:#4c81c0 !important;
  font-size:14px;
  text-align:center;
  margin-bottom:20px;
  font-weight:700;
}
.website a{
  color:#4c81c0 !important;
}
.showComments{
  cursor:pointer;
  position:relative;
}

.showComments img{
  width:30px;
}
.sidePannel{
  position: fixed;
  right: 0;
  width: min(100%,500px);
  background: #FFF;
  top: 0;
  height: 100vh;
  z-index: 999;
  overflow: scroll;

}

.oneFilter{
  padding-top: 20px;
  padding-bottom: 20px;
}
.oneFilter:not(:last-child){
border-bottom: 1px solid #ddd;
}
.oneFilter .filtreName{
  margin-bottom:10px;
  display:block;
  color:#4c81c0;
}
.oneFilter .value_possible{
  max-height:300px;
  overflow: scroll; /* Always show both horizontal and vertical scrollbar */
    scrollbar-width: thin; /* Firefox */
    scrollbar-color: #333 #fff; /* Firefox */
}

.oneFilter .value_possible::-webkit-scrollbar {
      width: 12px; /* Width of the scrollbar */
    }

.oneFilter .value_possible::-webkit-scrollbar-thumb {
      background-color: #333; /* Color of the thumb */
    }
.oneFilter .value_possible::-webkit-scrollbar-track {
      background-color: #fff; /* Color of the track */
    }

    .sidePannel .filters{
      overflow: scroll;
  padding: 30px;
  height: calc(100vh - 100px);
    }

  .sidePannel .create_filters{
    overflow: scroll;
padding: 30px;
height: calc(100vh);
  }
    .footerPannel{
      position: static;
  height: 100px;
  border-top: 2px solid #4c81c0;
  padding:20px;
  text-align:right;
    }

      .footerPannel .btn{
      padding:5px 10px;
      background:#4c81c0;
      color:#FFF;
      font-size:15px;
      border-radius: 20px;
      border:1px solid #4C81C0;
      margin:10px;
    }

    .footerPannel .btn_invert{
    padding:5px 10px;
    color:#4c81c0;
    background:#FFF;
    font-size:15px;
    border-radius: 20px;
    border:1px solid #4C81C0;
    margin:10px;
  }
  .triangle{
    width:15px;
  }

  .triangle.open{
    transform:rotate(180deg);
  }

  .candidate_card.isChecked{
    border-color:#4C81C0;
  }
  .candidate_card.isChecked .checkbox__icon .fond{
    fill:#FFF !important;
  }

  /* .candidate_card.isAssess{
    border-color:#ad8e41;
  } */
  /* .candidate_card.isAssess .candidate_card_head{
    background:#ad8e41;
  } */
.goRight{
  margin-left:auto;
  display:flex;
  flex-wrap:wrap;
  gap:20px;
}
.extraPoolsContainer{
  position:relative;
}
.extraPoolsIcons{
  width:20px;
}
.extraPoolsNumber{
  background: #B38D2F;
  color: #FFF;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}

.isAssess .extraPoolsNumber{
  color: #B38D2F;
  background: #FFF;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}
.nb_item_comments{
  background: #B38D2F;
  color: #FFF !important;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}

.action_zone{
  position: sticky;
    right: 0;
    top: 0;
    background: #4C81C0;
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;

}
.actionZoneTitle{
  color: #FFF;
  font-weight: bold;
  font-size: 20px;
    text-transform: uppercase;
}

.p-rl-50{
  padding-left:50px;
  padding-right:50px;
}

.action_btn,
.action_btn:hover{
  background: #FFF;
  color: #000;
  padding: 5px 15px;
  font-weight: 600;
  border-radius: 200px;
}
.back_btn,
.back_btn:hover{
  background: #FFF;
  color: #000;
  padding: 10px 25px;
  font-weight: 400;
  border-radius: 200px;
}
.disabledRlink{
  pointer-events: none;
  opacity: 0.7;
}

.zoneBtn{
  position:relative;
  display: flex;

}


.whyDisabled{
  position: absolute;
  background: #EFEFEF;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.enableWhyDisabled:hover .whyDisabled{
  display:block;
}

.hoverInfo{
  position: absolute;
  background: #EFEFEF;
  color:#000 !important;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.extraPoolsContainer:hover .hoverInfo{
  display:block;
}

.filter_content_title{
  text-transform:uppercase;
  font-weight:600;
}

.v-slider-track__background--opacity {
  opacity: 1;
}

.selectAll{
  border: 2px solid #4c81c0;
  padding: 10px 20px;
  border-radius: 200px;
  cursor: pointer;
}


[data-tooltip] {
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  position: relative;
  margin-right: auto;
}
[data-tooltip]::after {
  background-color: rgba(51, 51, 51, 0.9);
  border-radius: 0.3rem;
  color: #fff;
  content: attr(data-tooltip);
  font-size: 1rem;
  font-size: 85%;
  font-weight: normal;
  line-height: 1.15rem;
  opacity: 0;
  padding: 0.25rem 0.5rem;
  position: absolute;
  text-align: center;
  text-transform: none;
  transition: opacity 0.2s;
  visibility: hidden;
  white-space: nowrap;
  z-index: 1;
}
[data-tooltip].tooltip-top::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: rgba(51, 51, 51, 0.9) transparent transparent transparent;
  top: 0;
  left: 50%;
  margin-left: -0.3rem;
}
[data-tooltip].tooltip-top::after {
  bottom: 100%;
  left: 50%;
  transform: translate(-50%);
}
[data-tooltip].tooltip-bottom::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent transparent rgba(51, 51, 51, 0.9) transparent;
  bottom: 0;
  left: 50%;
  margin-left: -0.3rem;
}
[data-tooltip].tooltip-bottom::after {
  top: 100%;
  left: 50%;
  transform: translate(-50%);
}
[data-tooltip].tooltip-left::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent transparent transparent rgba(51, 51, 51, 0.9);
  top: 0.3rem;
  right: calc(110% - 0.3rem);
  margin-top: -0.3rem;
}
[data-tooltip].tooltip-left::after {
  top: -0.3rem;
  right: calc(110% + 0.3rem);
}
[data-tooltip].tooltip-right::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent rgba(51, 51, 51, 0.9) transparent transparent;
  top: 50%;
  top: 0.3rem;
  left: calc(110% - 0.3rem);
  margin-top: -0.3rem;
}
[data-tooltip].tooltip-right::after {
  top: -0.3rem;
  left: calc(110% + 0.3rem);
}
@media (max-width: 767px) {
  [data-tooltip].tooltip-mobile::before {
    display: none;
  }
  [data-tooltip].tooltip-mobile:after {
    font-size: 1rem;
    max-width: 20rem;
    position: fixed;
    bottom: auto;
    top: 50%;
    left: 50%;
    text-align: left;
    transform: translate(-50%);
    white-space: normal;
  }
}
[data-tooltip]:hover::after, [data-tooltip][class*=tooltip-]:hover::before {
  visibility: visible;
  opacity: 1;
}

.poolTitle .customH2{
  color:#B38D2F;
}

.poolTitle .customH2 .sfname{
  font-weight: 700;
  text-transform:uppercase;
}



.quicksearch .input{
  max-width: 200px;
    border: 1px solid #fff;
    background: transparent;
    padding: 5px 20px;
    border-radius: 200px;
    outline: none;
    color: #fff;
    font-weight: bold;
    letter-spacing: 1px;
}



.slider_mini_score{
  max-width: 350px;
  min-width: 300px;
}
@media screen and (max-width:990px){
  .quicksearch{
    max-width: 100%;
    width:100%;
    margin-top:20px;
  }
  .quicksearch .input{
    max-width: 100%;
    width:100%;
      border: 1px solid #fff;
      background: transparent;
      padding: 5px 20px;
      border-radius: 200px;
      outline: none;
      color: #fff;
      font-weight: bold;
      letter-spacing: 1px;
  }
  .filtre_list_2{
    width:100%;
    flex:1;
  }
}
.moneyEntryLine{
  width: 100%;

}
.moneyEntryName{
    color:#333;
}
.moneyEntryInput{
  flex:1;

}

.moneyEntryLine select{
  -moz-appearance: menulist;
  -webkit-appearance: menulist;
}

.m-rlb-50{
  margin-left: 50px;
  margin-right: 50px;
  margin-bottom: 50px;
}
</style>
<style media="screen" >
  .vcp__header{
    background-color:#3783C5 !important;
    color:#FFF !important;
    padding:20px !important;
  }
  .vcp__body {
 border-top: 1px solid #3783C5 !important;
}
.vcpg{
   border: 1px solid #3783C5 !important;
}
  .vcp__header .customH2{
    font-size:20px;
    line-height:20px;
    margin:0;
  }

  .links_2{
    border-top: 1px solid #DDD;
  }
  .input_filtre{
    border: 1px solid #4c81c0;
    width: 100%;
    padding: 5px;
    margin-bottom: 20px;

  }
  .v-slider-track__background--opacity {
    opacity: 1;
  }

.nodeco{
  text-decoration: none;
  color:inherit;
}

.btn.remove{
  border:1px solid #C63221;
  color:#C63221;
  background:#FFF;
  padding:5px 10px;
  font-size:12px;
  line-height: 15px;
  margin-left:10px;
  align-self: center;
}
</style>
